var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "building u-row",
      on: {
        mouseenter: function($event) {
          return _vm.hover({ building: _vm.building.id })
        },
        mouseleave: function($event) {
          return _vm.hover({ building: false })
        }
      }
    },
    [
      _c("ui-image", {
        ref: "image",
        staticClass: "image",
        attrs: { src: _vm.src }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content u-flex" },
        [
          _c("p", { staticClass: "u-cut w7 cl-blue" }, [
            _vm._v(_vm._s(_vm.building.name))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "u-cut address" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.building.address) + "\n            "
            ),
            _vm.building.builtAt
              ? _c("span", [
                  _vm._v(", " + _vm._s(_vm._f("date")(_vm.building.builtAt)))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm._l(_vm.building.deals, function(deal) {
            return _c("building-deal", {
              key: deal.id,
              staticClass: "deal",
              attrs: { deal: deal },
              on: {
                select: function($event) {
                  return _vm.select({ deal: deal, building: _vm.building })
                }
              }
            })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }